import util from '@/helper/util'
import { createStore } from 'vuex'

export default createStore({
  state: {
    data: {}
  },
  getters: {
    data(state) {
      return state.data
    }
  },
  mutations: {
    SET_DATA(state, payload) {
      util.setObjectVal(state.data, [...payload.keys], payload.value)
    },
    INIT_DATA(state, payload) {
      state.data = {
        ...payload
      }
    }
  }
})
